import { create } from 'zustand';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

// Enable UTC mode for dayjs
dayjs.extend(utc);

const generateRungDetails = (numberOfRungs, totalMaturity) => {
  const today = dayjs().utc();
  const k = totalMaturity / numberOfRungs;
  
  return Array.from({ length: numberOfRungs }, (_, i) => {
    const targetDate = today.add((i + 1) * k, 'month');
    const calculatedMinDate = targetDate.subtract(90, 'day');
    
    // Ensure minMaturity is not in the past
    const minMaturity = (calculatedMinDate.isBefore(today) ? today : calculatedMinDate).format('YYYY-MM-DD');
    const maxMaturity = targetDate.add(90, 'day').format('YYYY-MM-DD');
    
    return { minMaturity, maxMaturity };
  });
};

export const useBondLadderRungFlowStore = create((set, get) => ({
  ladderData: null,
  rungsDetail: [],
  
  setLadderData: (data) => {
    const { numberOfRungs, totalMaturity, ...rest } = data;
    const rungsDetail = generateRungDetails(Number(numberOfRungs), Number(totalMaturity));
    
    const enrichedData = {
      ...rest,
      numberOfRungs,
      totalMaturity,
      rungsDetail
    };
    
    set({ ladderData: enrichedData, rungsDetail });
  },
  
  clearLadderData: () => set({ ladderData: null, rungsDetail: [] })
}));
